<template>
  <div class="goods-sku">
    <div class="type-list" v-for="(item, index) in props.goods.skuList" :key="item.id">
      <div class="title">
        {{ item.name }} <span>{{ state.current[index]?.name }}</span>
      </div>
      <div class="list scrollbar">
        <div
          class="type-item"
          v-for="it in item.list"
          :key="it.id"
          :class="getTypeClass(it, index)"
          @click="handleClick(it, index)"
        >
          <el-popover
            v-if="props.goods.showImgIndex === index && state.optionSpecs.includes(it.id)"
            placement="bottom"
            effect="dark"
            popper-class="imgPopper"
            :width="70"
            hide-after="0"
            trigger="hover"
            :content="it.name"
            :teleported="false"
          >
            <template #reference>
              <img :src="it.picUrl || props.goods.images[0]" referrerpolicy="no-referrer" />
            </template>
          </el-popover>
          <img
            v-else-if="props.goods.showImgIndex === index && !state.optionSpecs.includes(it.id)"
            :src="it.picUrl"
            referrerpolicy="no-referrer"
          />
          <template v-else> {{ it.name }}</template>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useUserStore } from '@/stores'
import { defineEmits, defineProps, reactive, watch } from 'vue'
import { useRoute } from 'vue-router'
import SpecAdjoinMatrix from '../adjoinArray.js'

const props = defineProps({
  goods: {
    type: Object,
    default: () => ({}),
  },
})
const $route = useRoute()
const skuList = []
const emit = defineEmits(['change', 'setPreviewImage', 'buyAction'])
const state = reactive({
  sizes: [],
  current: new Array(props.goods?.skuList?.length || 0).fill(null),
  currentSize: {},
  isInit: false,
})
const userStore = useUserStore()
const nameKey = userStore.language === 'cn' ? 'prop_name' : 'prop_name_en'
// const valKey = userStore.language === 'cn' ? 'value_name' : 'value_name_en'
const getAttr = (key = 'attr') => {
  return state.current
    .filter((item) => item)
    .map((item) => item[key])
    .join(';')
}
// 获取skuId
const getSkuId = () => {
  const skus = props.goods.skus
  for (let i = 0; i < skus.length; i++) {
    const skuItem = skus[i]
    const propArr = skuItem.propArr
    if (propArr.every((_, index) => propArr[index].value_id === state.current[index].id)) {
      return skuItem
    }
  }
}
// 获取 规格 类名
const getTypeClass = (typeItem, index) => {
  // console.log(typeItem, index)
  return {
    active: state.current.map((item) => item?.id).includes(typeItem.id),
    disabled: !state.optionSpecs.includes(typeItem.id),
    'size-item': !(props.goods.showImgIndex === index),
    'size-item-img': props.goods.showImgIndex === index,
  }
}

const handleClick = function (typeItem, index, resolve) {
  const bool = state.optionSpecs.includes(typeItem.id)
  // 排除可选规格里面没有的规格
  if (state.current[index]?.id !== (typeItem?.id || '') && !bool) return
  // 判断是否已经被选中了
  if (state.current[index]?.id === (typeItem?.id || '')) {
    return
  }
  state.current[index] = typeItem
  state.current = state.current.slice()
  state.optionSpecs = state.specAdjoinMatrix.getSpecscOptions(state.current.map((item) => item?.id))
  props.goods.showImgIndex === index &&
    emit('setPreviewImage', typeItem.picUrl || props.goods.images[0])

  const isCompete = state.current.every((item) => item)
  const sku = { ...state.current[index] }
  if (isCompete) {
    const skuItem = getSkuId()
    const attr = getAttr()
    const attrCn = getAttr('attrCn')
    sku.skuId = skuItem.skuId
    sku.img = skuItem.picUrl || props.goods.images[0]
    sku.attr = attr
    sku.attrCn = attrCn
    sku.inventory = skuItem.quantity
    sku.quantity = skuItem.quantity
    sku.writePrice = skuItem.promotionPrice || skuItem.price
    sku.promotionPrice = skuItem.promotionPrice
    sku.price = skuItem.price
  }
  emit('change', {
    sku,
    isCompete,
    resolve,
  })
}
// 生成sku相关数据
const generateSkuList = () => {
  skuList.splice(0, skuList.length - 1)
  props.goods.skus.forEach((sku) => {
    sku.quantity >= 1 &&
      skuList.push({
        id: sku.skuId,
        specs: sku?.propArr?.map((prop) => prop.value_id),
      })
  })
  state.specAdjoinMatrix = new SpecAdjoinMatrix(props.goods.skuList, skuList)
  state.current = Array(props.goods.skuList.length).fill(null)
  state.optionSpecs = state.specAdjoinMatrix.getSpecscOptions(state.current)
}

const initSku = async () => {
  if (state.isInit) return
  state.isInit = true
  const { skuId } = $route.query
  if (skuId) {
    const skuItem = props.goods.skus.find((sku) => sku.thirdSkuId === skuId)
    for (let typeIndex = 0; typeIndex < skuItem.propArr.length; typeIndex++) {
      const prop = skuItem.propArr[typeIndex]
      const parentTypeItem = props.goods.skuList.find((item) => item.name === prop[nameKey])
      const index = parentTypeItem?.list?.findIndex((item) => item.id === prop.value_id)
      if (typeof index === 'number' && index >= 0) {
        await new Promise((resolve) => handleClick(parentTypeItem.list[index], typeIndex, resolve))
      }
    }

    // emit('buyAction', type)
  }
}

watch(
  () => props.goods.skuList,
  () => {
    generateSkuList()
    initSku()
  },
  { immediate: true },
)
</script>
<style scoped lang="scss">
.goods-sku {
  .type-list {
    margin-bottom: 20px;
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 4px;
  }

  .title {
    font-family: Montserrat;
    font-size: 18px;
    font-weight: bold;
    line-height: normal;
    text-transform: capitalize;
    letter-spacing: 0em;
    color: var(--black-color-9);

    // margin-bottom: 25px;
    span {
      color: var(--primary-color);
      padding-left: 14px;
    }
  }

  .type-item {
    cursor: pointer;
    margin-right: 12px;
    box-sizing: border-box;

    &.active {
      color: var(--primary-color);

      img {
        border: 2px solid var(--primary-color);
      }
    }

    &.disabled {
      cursor: not-allowed;
      filter: brightness(0.9);
    }

    .popover-name {
      text-align: center;
      color: var(--white-color-1);
      font-size: 12px;
      background-color: var(--border-black-1);
      padding: 6px 12px;
    }

    img {
      width: 48px;
      height: 48px;
      border: 1px solid transparent;
      border-radius: 4px;
    }
  }

  .size-list {
    display: flex;
    flex-wrap: wrap;
  }

  .size-item {
    border: 1px solid var(--border-da);
    padding: 8px 16px 7px;
    margin-right: 12px;
    margin-top: 16px;
    cursor: pointer;
    border-radius: 8px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    text-transform: capitalize;
    letter-spacing: 0em;
    color: var(--black-color-9);

    &.active {
      border: 2px solid var(--primary-color);
    }

    &.disabled {
      pointer-events: none;
      background: #f2f2f2;
      color: #999;
      opacity: 0.3;
    }
  }

  .size-item-img {
    margin-top: 16px;

    &.disabled {
      opacity: 0.3;

      img {
        background: #8a8a8a;
      }
    }
  }
}

.imgPopper {
  text-align: center;
  background-color: var(--border-black-1);
}
</style>
